import { Controller } from '@hotwired/stimulus'

const COMPLETO = 'rnk-ProductFilterAndSearch-completo'

/*
 * Panel de filtros de los comparadores (`.rnk-ProductFilterAndSearch`). Va
 * sticky y limitado al alto de la ventana, con scroll propio, para que con un
 * listado largo se vea entero mientras se baja por él.
 *
 * Con un listado más corto que el panel, ese límite lo deja cortado a media
 * opción: la fila de la rejilla mide lo que el más alto de los dos, el panel
 * no pasa de una pantalla y lo que sobra queda dentro de su scroll, sin ninguna
 * señal. Ahí se quita el límite: el panel se ve entero y la fila crece con él.
 *
 * No se resuelve con CSS: el alto de la fila depende del propio panel.
 *
 * Se observan el panel, el listado y sus hijos: los filtros y la paginación
 * cambian el listado dentro del turbo-frame sin cambiar el alto de la fila, y
 * «Ver todas» alarga el contenido del panel sin cambiar el alto del panel.
 */
export default class extends Controller {
  connect () {
    this.listado = this.element.closest('.rnk-ProductComparerWrapper')?.querySelector(':scope > main')
    if (!this.listado) return

    this.observador = new ResizeObserver(() => this.programa())
    for (const elemento of [this.element, ...this.element.children, this.listado, ...this.listado.children]) {
      this.observador.observe(elemento)
    }
  }

  disconnect () {
    this.observador?.disconnect()
    cancelAnimationFrame(this.pendiente)
    this.element.classList.remove(COMPLETO)
  }

  // Fuera de la retrollamada del observador: cambiar ahí el alto del panel, que
  // también se observa, dispara el aviso «ResizeObserver loop» del navegador.
  programa () {
    cancelAnimationFrame(this.pendiente)
    this.pendiente = requestAnimationFrame(() => this.ajusta())
  }

  // En móvil el panel está oculto o abierto como modal: no hay nada que medir.
  // Se mide con los dos a su alto natural (el panel sin límite y fuera del
  // sticky, el listado sin estirar) y se restaura todo antes de pintar.
  ajusta () {
    const { display, position } = getComputedStyle(this.element)
    if (display === 'none' || position !== 'sticky') return

    const estiloPanel = this.element.style
    const estiloListado = this.listado.style

    estiloPanel.maxHeight = 'none'
    estiloPanel.position = 'static'
    estiloListado.alignSelf = 'start'
    const sobra = this.element.getBoundingClientRect().bottom - this.listado.getBoundingClientRect().bottom
    estiloPanel.maxHeight = ''
    estiloPanel.position = ''
    estiloListado.alignSelf = ''

    this.element.classList.toggle(COMPLETO, sobra > 0)
  }
}
